export enum OrderImportStatusCodeEnum {
  Error = -1,
  PreviouslyImportedOrder = 0,
  Success = 1
}